import { Table } from "react-bootstrap";
import type { ModelAssignmentData } from "../../lib/explainTypes";

interface Props {
  modelAssignment: ModelAssignmentData;
}

// Strategy === "preference". Renders the rules matrix from
// `model_assignment.rules`.
export default function PreferenceAssignmentView({ modelAssignment }: Props) {
  if (modelAssignment.rules.length === 0) {
    return <p className="text-muted">No preference rules recorded.</p>;
  }
  return (
    <Table size="sm">
      <thead>
        <tr>
          <th>Account</th>
          <th>Model</th>
          <th>Source</th>
          <th>Notes</th>
        </tr>
      </thead>
      <tbody>
        {modelAssignment.rules.map((r) => (
          <tr key={r.account_id}>
            <td>{r.account_id}</td>
            <td>{r.model_name ?? "—"}</td>
            <td>{r.source}</td>
            <td>{r.explanation}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
